module.exports = __webpack_public_path__ + "static/media/logo.fda0c195.svg";